const FeedbackVisibilities = Object.freeze({
	Visible: "visible",
	Hidden: "hidden",
});

type FeedbackVisibility = typeof FeedbackVisibilities[keyof typeof FeedbackVisibilities];

export default FeedbackVisibility;
export {FeedbackVisibilities};
